import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { RxEyeClosed } from "react-icons/rx";
import { IoEyeOutline } from "react-icons/io5";
import Lottie from "lottie-react";
import winnerData from "../../assets/winner.json";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthApis } from "../../../apis/authApis";
import { toast, ToastContainer } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { login } from '../../reducer/loginSlice';
import 'react-toastify/dist/ReactToastify.css';
import OnboardingBg from "../../../img/Onboarding.png";
import LoadingSpinner from "../../UI/LoadingSpinner";
import ActionButtons from "../../ActionButtons";

// Type definitions
interface CountryType {
    code: string;
    flag: string;
    dialCode: string;
    name?: string;
}

interface CarouselItem {
    image: string;
    title: string;
    description: string;
}

// Carousel items data
const carouselItems: CarouselItem[] = [
    {
        image: "/images/graduation-hat.png",
        title: "Comprehensive Student Support",
        description: "Providing additional services such as affordable travel arrangements, travel and health insurance, and more."
    },
    {
        image: "/images/coins04.png",
        title: "Multi-Currency Support",
        description: "Enabling payments in various currencies, with seamless conversion options."
    },
    {
        image: "/images/Saly-44.png",
        title: "Diverse Payment Methods",
        description: "Supporting multiple payment options, including bank transfers, cards, mobile money, and cryptocurrencies."
    },
    // {
    //     image: "/images/Card02.png",
    //     title: "Virtual and Physical Cards",
    //     description: "Simplifying transactions with easy-to-use cards for Everyone"
    // },
    {
        image: "/images/Safe02.png",
        title: "Interest-Earning Accounts",
        description: "Offering savings in international currencies with attractive annual interest rates."
    }
];

/**
 * Registration component
 */
function NewRegister(): JSX.Element {
    // UI state
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [screen, setScreen] = useState<number>(1);
    const [showScreen, setShowScreen] = useState<number>(1);
    const [currentSlide, setCurrentSlide] = useState<number>(0);

    // Form state (focus states)
    const [isMnameFocused, setIsMnameFocused] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [isFnameFocused, setIsFnameFocused] = useState<boolean>(false);
    const [isSurnameFocused, setIsSurnameFocused] = useState<boolean>(false);
    const [isPhoneFocused, setIsPhoneFocused] = useState<boolean>(false);
    const [isEmailFocused, setIsEmailFocused] = useState<boolean>(false);
    const [isPasswordFocused, setIsPasswordFocused] = useState<boolean>(false);
    const [isConfirmFocused, setIsConfirmFocused] = useState<boolean>(false);

    // Form values
    const [surname, setSurname] = useState<string>('');
    const [f_name, setF_name] = useState<string>('');
    const [m_name, setM_name] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const [phone, setPhone] = useState<string>('');

    // Form validation state
    const [passwordMatch, setPasswordMatch] = useState<boolean>(true);
    const [showPasswordRequirements, setShowPasswordRequirements] = useState<boolean>(false);
    const [emailError, setEmailError] = useState<string>('');
    const [passwordError, setPassordError] = useState<string>('');

    // Registration and request state
    const [loading, setLoading] = useState<boolean>(false);
    const [userId, setUserId] = useState<number | null>(null);
    const [userIdStr, setUserIdStr] = useState<string>("");
    const [maskedPhone, setMaskedPhone] = useState<string>('');

    // Country selection
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedCountry, setSelectedCountry] = useState<CountryType>({
        code: 'NG', flag: '🇳🇬', dialCode: '+234'
    });

    // OTP verification state
    const [verificationCode, setVerificationCode] = useState<string[]>(['', '', '', '', '', '']);
    const [timer, setTimer] = useState<number>(300); // 5:00 in seconds
    const [showCode, setShowCode] = useState<boolean>(false);
    const [showResendAlert, setShowResendAlert] = useState<boolean>(false);
    const [invalidOtp, setInvalidOtp] = useState<boolean>(false);

    // Redux state and router hooks
    const [searchParams] = useSearchParams();
    const [refId, setRefId] = useState<string | null>(null);
    const [showReferralSuccess, setShowReferralSuccess] = useState<boolean>(false);
    const [isRefFromUrl, setIsRefFromUrl] = useState<boolean>(false);
    const userLoginData = useSelector((state: any) => state.data.login.value);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const ref = searchParams.get('ref') || searchParams.get('referral');

        if (!ref) return;

        window.location.href = `goafripay://sign-up?ref=${encodeURIComponent(ref)}`;

        const timer = setTimeout(() => {
            const isAndroid = /android/i.test(navigator.userAgent);
            const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

            if (isAndroid) {
                window.location.href = `https://play.google.com/store/apps/details?id=com.afripay.afripay&referrer=ref%3D${encodeURIComponent(ref)}`;
            } else if (isIOS) {
                window.location.href = 'https://apps.apple.com/app/6757638682';
            }
            // Desktop → stays on web signup page with ref already in URL
        }, 2500);

        return () => clearTimeout(timer);
    }, []);

    // Refs for OTP inputs
    const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

    // Countries data
    const countries: CountryType[] = [
        { code: 'NG', flag: '🇳🇬', dialCode: '+234' },
        // { code: 'NO', flag: '🇳🇴', dialCode: '+47' },
        // { code: 'US', flag: '🇺🇸', dialCode: '+1' },
        // { code: 'GB', flag: '🇬🇧', dialCode: '+44' },
        // { code: 'GH', flag: '🇬🇭', dialCode: '+233', name: 'Ghana' },
        // { code: 'CM', flag: '🇨🇲', dialCode: '+237', name: 'Cameroon' },
        // { code: 'KE', flag: '🇰🇪', dialCode: '+254', name: 'Kenya' },
        // { code: 'MW', flag: '🇲🇼', dialCode: '+265', name: 'Malawi' },
        // { code: 'ZA', flag: '🇿🇦', dialCode: '+27', name: 'South Africa' },
        // { code: 'UG', flag: '🇺🇬', dialCode: '+256', name: 'Uganda' },
        // { code: 'ZW', flag: '🇿🇼', dialCode: '+263', name: 'Zimbabwe' },
        // { code: 'FI', flag: '🇫🇮', dialCode: '+358', name: 'Finland' },
    ];

    // Handle referral parameter from URL
    useEffect(() => {
        const referralCodeFromURL = searchParams.get('ref');
        console.log('Referral code from URL:', referralCodeFromURL);

        if (referralCodeFromURL) {
            setRefId(referralCodeFromURL);
            setIsRefFromUrl(true); // Mark that this came from URL
            setShowReferralSuccess(true);

            // Show success message for 5 seconds
            setTimeout(() => {
                setShowReferralSuccess(false);
            }, 5000);

            // Store referral code in localStorage for later use
            localStorage.setItem('afripay_referral_code', referralCodeFromURL);
        } else {
            // Check if there's a stored referral code from previous session
            const storedRefCode = localStorage.getItem('afripay_referral_code');
            if (storedRefCode) {
                setRefId(storedRefCode);
                setIsRefFromUrl(true); // Also disable if from storage
            }
        }
    }, [searchParams]);

    // Check if passwords match when either field changes
    useEffect(() => {
        // Only validate if both fields have values
        if (confirmPassword) {
            setPasswordMatch(password === confirmPassword);
        } else {
            // Don't show error when confirm field is empty
            setPasswordMatch(true);
        }
    }, [password, confirmPassword]);

    // Handle the checkbox change
    const handleCheckboxChange = (): void => {
        setIsChecked(!isChecked);
    };

    // Format timer as MM:SS
    const formatTime = (timeInSeconds: number): string => {
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    // Timer countdown effect
    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer(prevTimer => prevTimer - 1);
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [timer]);

    // Carousel Auto-rotation
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
        }, 5000);

        return () => clearInterval(timer);
    }, []);

    /**
     * Handle phone number input changes
     */
    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        // Only keep the digits, no formatting
        const value = e.target.value.replace(/[^0-9]/g, '');
        setPhone(value);
    };

    /**
     * Handle password input changes
     */
    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setPassword(e.target.value);
    };

    /**
     * Handle confirm password input changes
     */
    const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setConfirmPassword(e.target.value);
    };

    /**
     * Validate password requirements
     */
    const validatePassword = () => {
        const hasLowercase = /[a-z]/.test(password);
        const hasUppercase = /[A-Z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        const hasMinLength = password.length >= 8;

        return {
            lowercase: hasLowercase,
            uppercase: hasUppercase,
            number: hasNumber,
            special: hasSpecialChar,
            length: hasMinLength,
        };
    };

    /**
     * Handle OTP code changes
     */
    const handleCodeChange = (index: number, value: string): void => {
        if (value.length <= 1) {
            const newCode = [...verificationCode];
            newCode[index] = value;
            setVerificationCode(newCode);

            // Auto move to next input
            if (value && index < 5) {
                inputRefs.current[index + 1]?.focus();
            }
        }
    };

    /**
     * Handle keydown events for OTP inputs
     */
    const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>): void => {
        if (e.key === 'Backspace' && !verificationCode[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        } else if (e.key === 'ArrowLeft' && index > 0) {
            inputRefs.current[index - 1]?.focus();
        } else if (e.key === 'ArrowRight' && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    /**
     * Handle paste events for OTP inputs
     */
    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>): void => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, 6);

        if (/^\d+$/.test(pastedData)) {
            const newCode = [...verificationCode];

            for (let i = 0; i < pastedData.length; i++) {
                if (i < 6) newCode[i] = pastedData[i];
            }

            setVerificationCode(newCode);

            // Focus the appropriate input after paste
            if (pastedData.length < 6) {
                inputRefs.current[pastedData.length]?.focus();
            } else {
                inputRefs.current[5]?.focus();
            }
        }
    };

    /**
     * Handle paste button click for OTP
     */
    const handlePasteButtonClick = async (): Promise<void> => {
        try {
            const clipText = await navigator.clipboard.readText();
            const digits = clipText.replace(/\D/g, '').slice(0, 6);

            if (digits.length > 0) {
                const newCode = [...verificationCode];

                for (let i = 0; i < digits.length; i++) {
                    if (i < 6) newCode[i] = digits[i];
                }

                setVerificationCode(newCode);

                // Focus the last filled input or the first empty one
                const focusIndex = Math.min(digits.length, 5);
                inputRefs.current[focusIndex]?.focus();
            }
        } catch (err) {
            console.error('Failed to read clipboard:', err);
        }
    };

    /**
     * Handle resend OTP code
     */
    const handleResendCode = (): void => {
        // Reset the timer
        setTimer(300); // 5:00
        setLoading(true);

        // Try to get user ID from state or session storage
        const userIdToUse = userId || Number(sessionStorage.getItem('afripay_user_id'));
        const userIdStrToUse = userIdStr || sessionStorage.getItem('afripay_user_id');

        if (!userIdToUse && !userIdStrToUse) {
            toast.error("User ID not found. Please try registering again.");
            setLoading(false);
            return;
        }

        // Prepare the data object as expected by the API
        const resendData: any = {
            user_id: userIdStrToUse
        };

        AuthApis.resendOtp(resendData)
            .then((response: any) => {
                if (response?.data?.success === true) {
                    // Reset verification code fields
                    setVerificationCode(['', '', '', '', '', '']);
                    // Show the resend alert
                    setShowResendAlert(true);
                    // Hide alert after 5 seconds
                    setTimeout(() => {
                        setShowResendAlert(false);
                    }, 5000);
                    toast.success(response.data.message || "OTP resent successfully");
                } else {
                    toast.error(response?.data?.message || "Failed to resend OTP");
                }
            })
            .catch((error: any) => {
                console.error("Error resending OTP:", error);
                toast.error(error.response?.data?.message || "Failed to resend OTP");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    /**
     * Store user data for profile setup
     */
    const storeUserDataForProfileSetup = (): void => {
        // Store user details in session storage for profile setup
        sessionStorage.setItem('afripay_first_name', f_name || '');
        sessionStorage.setItem('afripay_last_name', surname || '');
        sessionStorage.setItem('afripay_middle_name', m_name || '');
        sessionStorage.setItem('afripay_phone_number', phone || '');
        sessionStorage.setItem('afripay_email', email || '');

        // Store in localStorage as a backup
        try {
            localStorage.setItem('afripay_user_data', JSON.stringify({
                first_name: f_name,
                last_name: surname,
                middle_name: m_name,
                phone_number: phone,
                email: email,
                user_id: userId || sessionStorage.getItem('afripay_user_id')
            }));
        } catch (e) {
            console.error("Could not store user data in localStorage", e);
        }
    };

    /**
 * Clean and format phone number with country code for backend
 * @param {string} phoneNumber - The phone number entered by user
 * @param {CountryType} country - The selected country object
 * @returns {string} - Formatted phone number with country code (e.g., "2348012345678")
 */
    const cleanPhoneNumberForBackend = (phoneNumber: string, country: CountryType): string => {
        if (!phoneNumber) return '';

        // Remove all non-digit characters first
        let digitsOnly = phoneNumber.replace(/[^0-9]/g, '');

        // Get the country dial code without the '+' sign
        const dialCode = country.dialCode.replace('+', '');

        // Handle different input formats based on country
        if (country.code === 'NG') { // Nigeria
            if (digitsOnly.startsWith(dialCode)) {
                // Format: 2348012345678 -> extract 8012345678
                return digitsOnly.length > dialCode.length ? digitsOnly : digitsOnly;
            } else if (digitsOnly.startsWith('234')) {
                // Format: 234xxxxxxxxxx -> already has code
                return digitsOnly.length > 3 ? digitsOnly : digitsOnly;
            } else if (digitsOnly.startsWith('0')) {
                // Format: 08012345678 -> extract 8012345678, add 234
                return digitsOnly.length > 1 ? dialCode + digitsOnly.substring(1) : digitsOnly;
            } else {
                // Format: 8012345678 -> add 234
                return dialCode + digitsOnly;
            }
        } else if (country.code === 'GH') { // Ghana
            if (digitsOnly.startsWith(dialCode)) {
                // Format: 233xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('233')) {
                // Format: 233xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('0')) {
                // Format: 0xxxxxxxxxx -> remove 0, add 233
                return digitsOnly.length > 1 ? dialCode + digitsOnly.substring(1) : digitsOnly;
            } else {
                // Format: xxxxxxxxxx -> add 233
                return dialCode + digitsOnly;
            }
        } else if (country.code === 'KE') { // Kenya
            if (digitsOnly.startsWith(dialCode)) {
                // Format: 254xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('254')) {
                // Format: 254xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('0')) {
                // Format: 0xxxxxxxxxx -> remove 0, add 254
                return digitsOnly.length > 1 ? dialCode + digitsOnly.substring(1) : digitsOnly;
            } else {
                // Format: xxxxxxxxxx -> add 254
                return dialCode + digitsOnly;
            }
        } else if (country.code === 'ZA') { // South Africa
            if (digitsOnly.startsWith(dialCode)) {
                // Format: 27xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('27')) {
                // Format: 27xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('0')) {
                // Format: 0xxxxxxxxxx -> remove 0, add 27
                return digitsOnly.length > 1 ? dialCode + digitsOnly.substring(1) : digitsOnly;
            } else {
                // Format: xxxxxxxxxx -> add 27
                return dialCode + digitsOnly;
            }
        } else if (country.code === 'CM') { // Cameroon
            if (digitsOnly.startsWith(dialCode)) {
                // Format: 237xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('237')) {
                // Format: 237xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('0')) {
                // Format: 0xxxxxxxxxx -> remove 0, add 237
                return digitsOnly.length > 1 ? dialCode + digitsOnly.substring(1) : digitsOnly;
            } else {
                // Format: xxxxxxxxxx -> add 237
                return dialCode + digitsOnly;
            }
        } else if (country.code === 'UG') { // Uganda
            if (digitsOnly.startsWith(dialCode)) {
                // Format: 256xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('256')) {
                // Format: 256xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('0')) {
                // Format: 0xxxxxxxxxx -> remove 0, add 256
                return digitsOnly.length > 1 ? dialCode + digitsOnly.substring(1) : digitsOnly;
            } else {
                // Format: xxxxxxxxxx -> add 256
                return dialCode + digitsOnly;
            }
        } else if (country.code === 'ZW') { // Zimbabwe
            if (digitsOnly.startsWith(dialCode)) {
                // Format: 263xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('263')) {
                // Format: 263xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('0')) {
                // Format: 0xxxxxxxxxx -> remove 0, add 263
                return digitsOnly.length > 1 ? dialCode + digitsOnly.substring(1) : digitsOnly;
            } else {
                // Format: xxxxxxxxxx -> add 263
                return dialCode + digitsOnly;
            }
        } else if (country.code === 'MW') { // Malawi
            if (digitsOnly.startsWith(dialCode)) {
                // Format: 265xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('265')) {
                // Format: 265xxxxxxxxxx -> already has code
                return digitsOnly;
            } else if (digitsOnly.startsWith('0')) {
                // Format: 0xxxxxxxxxx -> remove 0, add 265
                return digitsOnly.length > 1 ? dialCode + digitsOnly.substring(1) : digitsOnly;
            } else {
                // Format: xxxxxxxxxx -> add 265
                return dialCode + digitsOnly;
            }
        } else if (country.code === 'US' || country.code === 'NO' || country.code === 'GB' || country.code === 'FI') {
            // For US, Norway, UK, Finland - these countries don't typically use leading 0
            if (digitsOnly.startsWith(dialCode)) {
                // Already has dial code
                return digitsOnly;
            } else {
                // Add dial code
                return dialCode + digitsOnly;
            }
        } else {
            // Generic handler for any other country
            if (digitsOnly.startsWith(dialCode)) {
                // Already has dial code
                return digitsOnly;
            } else if (digitsOnly.startsWith('0')) {
                // Remove leading 0 and add dial code
                return digitsOnly.length > 1 ? dialCode + digitsOnly.substring(1) : digitsOnly;
            } else {
                // Just add dial code
                return dialCode + digitsOnly;
            }
        }
    };

    /**
     * Handle form submission
     */
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        setLoading(true);

        // Clean phone number with country code
        const cleanedPhone = cleanPhoneNumberForBackend(phone, selectedCountry);

        const formData = new FormData();
        formData.append('first_name', f_name);
        formData.append('middle_name', m_name);
        formData.append('last_name', surname);
        formData.append('email', email);
        // formData.append('phone_number', phone);
        formData.append('phone_number', cleanedPhone);
        formData.append('password_confirmation', confirmPassword);
        formData.append('password', password);

        if (refId) {
            formData.append('referral_code', refId);
            // console.log('Adding referral code to registration:', refId);
        }

        AuthApis.register(formData)
            .then((response) => {
                if (response?.data) {
                    if (response?.data?.success === true) {
                        // Store the user ID for OTP verification - both as number and string
                        const userIdFromResponse = response.data.data.user_id;
                        setUserId(Number(userIdFromResponse));
                        setUserIdStr(String(userIdFromResponse));

                        // Store in session storage as backup
                        sessionStorage.setItem('afripay_user_id', String(userIdFromResponse));

                        // Format phone for display
                        if (phone.length > 4) {
                            const firstPart = phone.substring(0, 2);
                            const lastPart = phone.substring(phone.length - 2);
                            setMaskedPhone(`${selectedCountry.dialCode}${firstPart}****${lastPart}`);
                        }
                        // Clear referral code from localStorage after successful registration
                        if (refId) {
                            localStorage.removeItem('afripay_referral_code');
                        }
                        setLoading(false);
                        setScreen(2); // Move to OTP verification screen
                        toast.success("Registration successful. Please verify your OTP.");
                    } else {
                        toast.error(response?.data?.message);
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                }
            })
            .catch((error) => {
                // Handle error
                console.error(error.response?.data);
                toast.error(error.response?.data?.message);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    /**
     * Handle OTP verification
     */
    const handleVerifyOtp = (): void => {
        setLoading(true);
        setInvalidOtp(false);

        // Combine the verification code array into a string
        const otpCode = verificationCode.join('');

        if (otpCode.length !== 6) {
            toast.error("Please enter a valid 6-digit OTP");
            setLoading(false);
            return;
        }

        // Try to get user ID from state or session storage
        const userIdToUse = userId || Number(sessionStorage.getItem('afripay_user_id'));
        const userIdStrToUse = userIdStr || sessionStorage.getItem('afripay_user_id');

        if (!userIdToUse && !userIdStrToUse) {
            toast.error("User ID not found. Please try registering again.");
            setLoading(false);
            return;
        }

        // Prepare verification data
        const verifyData: any = {
            user_id: userIdStrToUse,
            otp: otpCode
        };

        AuthApis.verifyOtp(verifyData)
            .then((response) => {
                if (response?.data?.success === true) {
                    // Store user data in Redux
                    if (response.data.data?.token) {
                        dispatch(login({
                            email: email,
                            isVerified: true,
                            token: response.data.data.token,
                            id: response.data.data.account_id || userIdToUse,
                            name: response.data.data.name,
                            data: response.data.data,
                            first_name: f_name,
                            last_name: surname,
                            middle_name: m_name,
                            phone_number: phone
                        }));
                    }

                    // Store user data for profile setup
                    storeUserDataForProfileSetup();

                    // Navigate to success screen
                    setShowScreen(2);
                    toast.success("OTP verified successfully");
                } else {
                    setInvalidOtp(true);
                    setTimeout(() => {
                        setInvalidOtp(false);
                    }, 5000);

                    toast.error(response?.data?.message || "OTP verification failed");
                }
            })
            .catch((error) => {
                console.error("Error verifying OTP:", error);
                setInvalidOtp(true);
                toast.error(error.response?.data?.message || "OTP verification failed");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // Password requirement component
    const PasswordRequirement = ({ met, text }: { met: boolean; text: string }) => (
        <div
            className={`flex flex-row rounded-[34px] py-0.5 px-2 items-center space-x-2 ${met ? 'bg-[#BCE4D1]' : 'bg-[#FFFFFF] border border-[#CBD5E1]'
                }`}
        >
            <span className={met ? 'text-[#22975F] ' : 'text-[#CBD5E1]'}>
                {met ?
                    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.917969 5.66797L2.95964 7.70963L9.08464 1.29297" stroke="#22975F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    :
                    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.08464 1.41797L0.917969 9.58464M0.917969 1.41797L9.08464 9.58464" stroke="#CBD5E1" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                }
            </span>
            <span className={met ? 'text-[#22975F] text-[10px]' : 'text-[#CBD5E1] text-[10px]'}>
                {text}
            </span>
        </div>
    );

    return (
        <>
            <div className={showScreen === 1 ? "block " : "hidden"}>
                <div className="fixed inset-0 w-full flex" style={{ height: '100vh', margin: 0, padding: 0 }}>
                    {/* Left Side - Carousel */}
                    <div
                        className="w-1/2 absolute left-0 top-0 bottom-0 overflow-hidden lg:block hidden"
                        style={{

                            backgroundImage: `url(${OnboardingBg})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            backgroundPosition: "center"
                        }}
                    >
                        {/* Carousel Content */}
                        <div className="relative flex items-center justify-center pb-10" style={{ height: '100vh' }}>
                            <div className="w-full max-w-md px-8">
                                <div className="overflow-hidden">
                                    <div
                                        className="flex transition-transform duration-500 ease-in-out"
                                        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                                    >
                                        {carouselItems.map((item, index) => (
                                            <div key={index} className="w-full flex-shrink-0 p-6">
                                                <img
                                                    src={item.image}
                                                    alt={item.title}
                                                    className="w-full h-64 object-contain mb-6"
                                                />
                                                <h2 className="text-xl text-center font-bold text-[#101010] mb-3">
                                                    {item.title}
                                                </h2>
                                                <p className="text-[#5D5D5D] text-[14px] text-center leading-relaxed">
                                                    {item.description}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Carousel Indicators */}
                                <div className="flex justify-center gap-2 mt-8">
                                    {carouselItems.map((_, index) => (
                                        <button
                                            key={index}
                                            className={`w-12 h-2 rounded-full transition-colors ${currentSlide === index ? 'bg-green-500' : 'bg-gray-300'
                                                }`}
                                            onClick={() => setCurrentSlide(index)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* flex items-center */}
                    <div className="lg:w-1/2 w-full bg-white absolute right-0 top-0 bottom-0 lg:left-1/2 left-0 overflow-y-auto flex items-center justify-center">
                        <div className="w-full max-w-xl px-8 lg:pl-24 py-8">
                            {/* Right Side - Sign Up Form */}
                            <div className="flex flex-col items-center">
                                <div className="flex justify-center mb-6 mt-10">
                                    <NavLink to="/" >
                                        <img src="/images/afripay-logo.png" alt="logo" />
                                    </NavLink>
                                </div>

                                <h1 className="lg:text-2xl text-[20px] font-bold text-center text-gray-800 mb-1.5">
                                    Get an AfriPay Account
                                </h1>

                                <p className="text-[#5D5D5D] text-[14px] text-center leading-relaxed mb-20">Borderless payments in your pocket — available on iOS and Android.</p>

                                < ActionButtons />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewRegister;